export default function generateHrefLink(url, router) {
   const rootPath = router.pathname.split('/')[1];
   if (['vaypol', 'city'].includes(rootPath)) {
      return `/${rootPath}/${url}`;
   }

   return `/${url}`;
}
